import React, { useState,useEffect } from "react";
import { BtnAlmacenar } from "componentes/templates/btn_crud";


export default function ModalSources({ ind_int_id }) {

  const [minispiner, setMinispiner] = useState(true)

  
  /* Arreglo con las variables para colocar los datos en el formulario */
  const variables = [
    "sou_txt_name",
    "sou_txt_responsable",
    "sou_txt_email",
    "sou_txt_phone",
    "sou_sts_register",
  
  ];

  
  const gestionarCambio = (event) => {
    if (event.target.type === "radio") {
      localStorage.setItem(event.target.name, event.target.value);
    } else {
      localStorage.setItem(event.target.id, event.target.value);
    }
  };

  const Verificar = (result) => {
    let resultado = JSON.parse(result);
    if (resultado.status === 201) {
      alert(resultado.messages);
      // limpiar el storage
      variables.forEach(function (valor) {
        localStorage.removeItem(valor);
      });
      window.location.reload();
    } else {
      // regresó error (normalmente 400), no pasó la validación
      variables.forEach(function (valor) {
        // es el mensaje de error q devuelve la validacion del codeigniter
        if (document.getElementById(valor + "_msj") !== null) {
          let mensaje = resultado.messages[valor];
          document.getElementById(valor + "_msj").classList.remove("is-hidden");
          document.getElementById(valor + "_msj").textContent = mensaje;
        }

      });
    }
  };


  const gAlmacenar = (e) => {
    e.preventDefault();
    
    

    // recorreremos todas las variables declaradas para crear el formulario
    let formdata = new FormData();
    variables.forEach(function (valor) {
      localStorage.getItem(valor) == null
        ? formdata.append(valor, "")
        : formdata.append(valor, localStorage.getItem(valor));
    });

    let requestOptions = {
      method: "POST",
      body: formdata,
    };
    for (var value of formdata.values()) {
      console.log(value);
   }
    let url = `${process.env.REACT_APP_BASE_BASE_URL}indicators/sources`;
    fetch(url, requestOptions)
      .then((response) => response.text())
      .then((result) => Verificar(result))
      .catch((error) => console.log("error", error));
  };

useEffect(() => {

    setMinispiner(false)
  
  // eslint-disable-next-line
}, [])

  return (
    <div className="container is-fluid">
      <div className="columns">
        <div className="column is-12 is-offset-0">
           <form autoComplete="nope">
            <div className="field">
              <label className="label">Nombre</label>
              <div className="control has-icons-left">
                <textarea
                 
                  placeholder="Nombre"
                  className="textarea"
                  id="sou_txt_name"
                  required
                  onChange={gestionarCambio}
                  maxLength="128"
                />
                
              </div>
              
            </div>

            <div className="field">
              <label className="label">Responsable</label>
              <div className="control has-icons-left">
                <textarea
                  type="text"
                  placeholder="Responsable"
                  className="input"
                  id="sou_txt_responsable"
                  required
                  onChange={gestionarCambio}
                  maxLength="128"
                />
                <span className="icon is-small is-left">
                  <i className={(minispiner) ? "fa fa-cog fa-spin" : "fas fa-users"}></i>
                </span>
              </div>
              
            </div>

            <div className="field">
              <label className="label">Email</label>
              <div className="control has-icons-left">
                <input
                  type="text"
                  placeholder="Email"
                  className="input"
                  id="sou_txt_email"
                  required
                  onChange={gestionarCambio}
                  maxLength="128"
                />
                <span className="icon is-small is-left">
                  <i className={(minispiner) ? "fa fa-cog fa-spin" : "fas fa-users"}></i>
                </span>
              </div>
              
            </div>

            <div className="field">
              <label className="label">Teléfono</label>
              <div className="control has-icons-left">
                <input
                  type="text"
                  placeholder="Teléfono"
                  className="input"
                  id="sou_txt_phone"
                  required
                  onChange={gestionarCambio}
                  maxLength="32"
                />
                <span className="icon is-small is-left">
                  <i className={(minispiner) ? "fa fa-cog fa-spin" : "fas fa-users"}></i>
                </span>
              </div>
              
            </div>

                   
            
         
              <BtnAlmacenar gAlmacenar={gAlmacenar}>Almacenar</BtnAlmacenar>
            
          </form>
        </div>
        

      </div>
    </div>
  );
}